﻿import { ApiCaller } from 'apis/ApiCaller';

export class ServicesApi {

    private static apiCaller = new ApiCaller('Services');

    public static loginAsGMetrixTC() {

        return this.apiCaller.GET<void>('LoginAsGMetrixTC');

    }

    public static getStudentLoginBridgeUrl() {

        return this.apiCaller.GET<string>('GetStudentLoginBridgeUrl');

    }

    public static getAuthorLoginBridgeUrl() {

        return this.apiCaller.GET<string>('GetAuthorLoginBridgeUrl');

    }

    public static setCulture(locale: string) {

        return this.apiCaller.GET<void>('SetCulture', { locale });

    }

    static setSidebarState = async (newValue: boolean): Promise<string> => this.apiCaller.GET<string>('SetSidebarState', { newValue });

}